import React from "react";
import { ShieldCheck, ShieldAlert, Shield } from "lucide-react";

// Icône GI/LAB du Portefeuille — état calculé par la règle unique du Centre
// de contrôle conformité (kyc-lab/conformite.js) :
//   ok      → vert   : toutes les rubriques sont complètes ;
//   encours → orange : KYC validé, d'autres éléments restent à traiter ;
//   alerte  → rouge  : KYC/LAB non validé ou à réexaminer.
const STYLES = {
  ok: { bg: "bg-emerald-100 hover:bg-emerald-200", fg: "text-emerald-600", Icon: ShieldCheck, label: "Dossier conforme" },
  encours: { bg: "bg-amber-100 hover:bg-amber-200", fg: "text-amber-600", Icon: Shield, label: "KYC validé — éléments en attente" },
  alerte: { bg: "bg-red-100 hover:bg-red-200", fg: "text-red-500", Icon: ShieldAlert, label: "Action requise — KYC/LAB à traiter" },
};

export default function GiLabIcon({ etat }) {
  const st = STYLES[etat?.statut] || STYLES.alerte;
  const { Icon } = st;
  return (
    <span
      title={`Centre de contrôle conformité — ${st.label}${etat ? ` (${etat.overall} %)` : ""}`}
      className={`inline-flex items-center justify-center w-6 h-6 rounded-md transition-colors ${st.bg}`}
    >
      <Icon className={`w-3.5 h-3.5 transition-colors ${st.fg}`} />
    </span>
  );
}
